<template>
  <button
    class="button"
    :class="disabled || loading ?'disabled':''"
  >
    <spinner v-if="loading"></spinner>
    <span
      v-if="loading && !xs"
      class="loading-text"
    > Chargement</span>
    <slot v-if="!loading"></slot>
  </button>
</template>

<script>
  import Spinner from './spinner';

  export default {
    name: 'CustomButton',
    components: { Spinner },
    props: ['disabled', 'loading', 'xs']
  };
</script>

<style scoped>
    .button {
        color: #333;
        transition: 0.5s ease all;
        cursor: pointer;
        border-radius: 5px;
        border: 1px solid rgba(255, 140, 0, 0.7);
        background: rgba(255, 140, 0, 0.1);
        font-size: 1.15em;
        line-height: 1.5em;
    }

    .button:hover {
        transition: 0.5s ease all;
        -moz-box-shadow: 0 0 6px 3px #ccc;
        -webkit-box-shadow: 0 0 6px 3px #ccc;
        -o-box-shadow: 0 0 6px 3px #ccc;
        box-shadow: 0 0 6px 3px #ccc;
        filter: progid:DXImageTransform.Microsoft.Shadow(color=#cccccc, Direction=0, Strength=6);
    }

    .button:active {
        transition: 0.1s ease all;
        -moz-box-shadow: inset 0 0 5px 0 #777;
        -webkit-box-shadow: inset 0 0 5px 0 #777;
        -o-box-shadow: inset 0 0 5px 0 #777;
        box-shadow: inset 0 0 5px 0 #777;
        filter: progid:DXImageTransform.Microsoft.Shadow(color=#cccccc, Direction=NaN, Strength=5);
    }

    .button:focus {
        outline: 0;
    }

    .button.disabled {
        color: #333;
        border: 1px solid #666;
        background: rgba(102, 102, 102, 0.1);
        pointer-events: none;

    }

    .red {
        color: darkred;
        border: 1px solid rgba(139, 0, 0, 0.7);
        background: rgba(139, 0, 0, 0.1);
    }

    .green {
        color: darkgreen;
        border: 1px solid rgba(0, 100, 0, 0.7);
        background: rgba(0, 100, 0, 0.1);
    }

    .loading-text {
        margin-left: 0.2em;
    }
</style>
